module.exports = __webpack_public_path__ + "static/media/calculus_cert_small.1f2eae1e.png";